var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7598 17.7599H6.23982V14.8799H4.31982V18.7199C4.31982 18.9749 4.42108 19.2186 4.60108 19.3986C4.78108 19.5786 5.02482 19.6799 5.27982 19.6799H18.7198C18.9748 19.6799 19.2186 19.5786 19.3986 19.3986C19.5786 19.2186 19.6798 18.9749 19.6798 18.7199V14.8799H17.7598V17.7599Z",
    fill: "#003A5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9596 15.8398V7.59821L14.8796 9.51821L16.2381 8.15976L12.6784 4.60104C12.4984 4.4201 12.2547 4.31885 11.9997 4.31885C11.7447 4.31885 11.5009 4.4201 11.3209 4.60104L7.76123 8.15976L9.11968 9.51821L11.0397 7.59821V15.8398H12.9596Z",
    fill: "#003A5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.5652fcd0f67feec701e61109d5fbad83.svg";
export { ForwardRef as ReactComponent };